module.exports = __webpack_public_path__ + "static/assets/73a31ba0e3ad544c7f83ecd5cc20193e.png";